(function (sb) {
	var me = (sb.SummaryCache = {});
	var varCache = {};
	var summaryDataCache = {};
	var reloadTimers = {};
	me.setSummaryDataToCache = function (data, id) {
		summaryDataCache[id] = data;
	}
	me.getSummaryDataFromCache = function (id) {
		return summaryDataCache[id];
	}
	me.setVariableToCache = function (variable, id) {
		varCache[id] = variable;
	}
	me.getVariableFromCache = function (id) {
		var cacheInfo = (typeof (varCache[id]) != "undefined") ? varCache[id] : {};
		return cacheInfo;
	}
	me.getSummaryReloadTimer = function (guid) {
		return reloadTimers[guid];
	}
	me.setSummaryReloadTimer = function (guid, duration) {
		reloadTimers[guid] = { start: Date.now(), duration: duration };
	}
})(window.Storyboard = (window.Storyboard || {}));

window.SummarySetup = {
	horizontalPosition: {
		LEFT: 1,
		CENTER: 2,
		RIGHT: 3,
	},
	verticalPosition: {
		TOP: 1,
		MIDDLE: 2,
		BOTTOM: 3
	},

	isLoaded: false,
	currentLayoutElementItem: [],
	loadTabs: function () {
		$("#summarytabholder").tabs("destroy");
		$('#summarytabholder').removeClass('ui-widget');
		$("#summarytabholder").tabs({
			show: function (evt, ui) {
				if (ui.index === 1) {
					$('#ais_FilterBox .filterboxHeaderWrapper td').equalHeights();
				}
				const disclaimerBox = document.querySelector("#ais_layout > fieldset > div.expandableContent:nth-child(4)");
				if (ui.index === 3 && document.querySelector("#ais_ddlDisclaimerType > option:checked").value === "2") {
					disclaimerBox.classList.add("hidden");
				} else {
					disclaimerBox.classList.remove("hidden")
                }
			}
		});
		$("#ais_layout").find(".ColorTextbox").DUIColorPicker({ layout: 'template' });
	},
	setupEditPanel: function (contentElement) {
		$("#ais_divPreview").empty().hide();
		SummarySetup.currentLayoutElementItem = contentElement;
		$('#ais_txtAvailVar').val('');
		if (!SummarySetup.isLoaded) {
			Storyboard.Dependency.start('SUMMARYSETUP', 'filters');
			Helpers.perfJSonCall({
				method: 'GetFilters',
				message: locale.get('Loading filters'),
				successCallback: function (filters) {
					SummarySetup.isLoaded = true;
					SummarySetup.bindFilters(filters);
					SummarySetup.setSummarySettings(contentElement);
					Storyboard.Dependency.complete('SUMMARYSETUP', 'filters');
				},
				fixCasing: true
			});
		} else {
			SummarySetup.setSummarySettings(contentElement);
		}
	},
	moveItems: function (sender) {
		var id = $(sender).attr("id");
		var selectFrom = id === "ais_btnMoveToSelVar" ? "#ais_availVarBox" : "#ais_selectedVarBox";
		var moveTo = id === "ais_btnMoveToAvailVar" ? "#ais_availVarBox" : "#ais_selectedVarBox";
		var selectedItems = $(selectFrom + " option:selected");
		var output = [];

		if (moveTo == "#ais_selectedVarBox" && $('#ais_selectedVarBox option').length > 0)
			return;

		selectedItems.each(function () {
			var $this = $(this);
			var alreadyInList = $(moveTo).find("option[value=" + $this.val() + "]").length > 0;
			if (!alreadyInList)
				output.push(this.cloneNode(true));
		});

		$(moveTo).append(output);

		selectedItems.remove();
		SummarySetup.enableDisableMoveButton();
	},
	enableDisableMoveButton: function () {
		if ($('#ais_selectedVarBox option').length > 0)
			$('#ais_btnMoveToSelVar').attr('disabled', 'disabled');
		else
			$('#ais_btnMoveToSelVar').removeAttr('disabled');
	},
	bindFilters: function (filterArray) {
		var template = $("#ais_FilterBox > .ais_filterboxTemplate");
		template.show();
		Storyboard.GuiEvents.bindFilters(filterArray, "ais_FilterBox", "ais_filterboxTemplate", false);
		Storyboard.GuiEvents.bindOptionalFilters(filterArray, "ais_optFilterBox", "ais_optionFilterTemplate", "ais_optionalFilterSettings");
		Storyboard.GuiEvents.bindOptionalFiltersCheckAll("ais_optFilterBox");
		template.hide();
	},
	setSummarySettings: function (contentElement) {
		Storyboard.Dependency.start('SUMMARYSETUP', 'settings');
		Helpers.perfJSonCall({
			method: 'GetSummarySettings',
			service: 'SummarySetup',
			message: locale.get('Loading settings'),
			data: { guid: contentElement.guid, layoutElementItemId: contentElement.elementItemId || 0 },
			successCallback: function (settings) {
				SummarySetup.loadAllVariables(settings);
				Storyboard.Dependency.complete('SUMMARYSETUP', 'settings');
			},
			fixCasing: true
		});
	},
	loadAllVariables: function (settings) {
		Helpers.perfJSonCall({
			method: 'LoadAllOpenEndedVariables',
			message: locale.get('Loading variables'),
			successCallback: function (variables) {
				$.each(variables, function () {
					Storyboard.SummaryCache.setVariableToCache(this, this.QuestionID);
				});
				SummarySetup.loadAvailOEVariables(variables);
				SummarySetup.bindSummarySettings(settings);
			}
		});
	},
	loadAvailOEVariables: function (variables) {
		for (var i in variables) {
			variables[i].aiIcon = variables[i].IsAICompute ? Storyboard.Constants.aiIconEntity : '';
		}

		HTMLHelpers.bindSelect($("#ais_availVarBox"), variables, "QuestionID", "QuestionText", false, false, false, false, ["aiIcon", "Code", "QuestionText"]);

		if ($("#ais_chbWCShowQuestionCode").is(":checked"))
			HTMLHelpers.resetOptionsTexts($("#ais_availVarBox"), ["Code", "QuestionText"], " - ");

		Storyboard.LayoutControls.showLoadingBar('Loading variables');
		$("#ais_availVarBox option").each(function () {
			var id = $(this).val();
			var variable = Storyboard.SummaryCache.getVariableFromCache(id);
			if (variable) {
				$(this).attr('title', HTMLHelpers.htmlDecode(variable.QuestionText));
			}
		});
		Storyboard.LayoutControls.hideLoadingBar();
	},
	clearMovedVariables: function () {
		$("#ais_selectedVarBox option").each(function (opt) {
			var option = $("#ais_selectedVarBox option").eq(opt);
			$('#ais_availVarBox option[value="' + option.attr("value") + '"]').remove();
		});
	},
	filterVariables: function () {
		var filter = $('#ais_txtAvailVar').val();
		SummarySetup.getFilterVariables(filter);
	},
	getFilterVariables: function (filter) {
		var data = {
			filterText: filter,
			filterByCode: $("#ais_chbShowQuestionCode").attr("checked"),
			variableSubsets: []
		}
		Helpers.perfJSonCall({
			method: "FilterOpenEndedVariables",
			data: data,
			successCallback: function (variables) {
				SummarySetup.loadAvailOEVariables(variables);
				SummarySetup.clearMovedVariables();
			},
			fixCasing: false
		});
	},
	bindSummarySettings: function (settings) {
		if (settings) {
			$('#hidSummaryId').val(settings.summaryId);
			SummarySetup.setSelectedQuestions(settings.selectedQuestions);

			$("#ais_selectedVarBox option").each(function () {
				var id = $(this).val();
				var variable = Storyboard.SummaryCache.getVariableFromCache(id);
				if (variable) {
					$(this).attr('title', HTMLHelpers.htmlDecode(variable.QuestionText));
				}
			});

			$('#ais_TimeSelections').find('.tpcDropDown').val(settings.timePeriod);
			$('#ddlDateVarAIS').val(settings.dateVariableId === 0 ? $('#ddlDateVarAIS').find('option[selected]').val() : settings.dateVariableId);
			$("#ais_TimeSelections").find("#ddlTimePeriodSpan").val(settings.timePeriodSpan);
			$("#ais_TimeSelections").find("#txtTimePeriod").val(settings.timePeriodSpanAmount);
			if (settings.timePeriod === 0)
				$("#ais_TimeSelections").find(".tpcStartDateInput, .tpcStopDateInput").show();
			else
				$("#ais_TimeSelections").find(".tpcStartDateInput, .tpcStopDateInput").hide();
			if (settings.timePeriod == 27) {
				$("#ais_TimeSelections").find("#ddlTimePeriodSpan").show();
				$("#ais_TimeSelections").find("#txtTimePeriod").show();
			} else {
				$("#ais_TimeSelections").find("#ddlTimePeriodSpan").hide();
				$("#ais_TimeSelections").find("#txtTimePeriod").hide();
			}

			if (settings.startEndPeriod) {
				$("#ais_TimeSelections").find(".dateInputStart").datepicker("setDate", Helpers.parseDate(settings.startEndPeriod.strStartDate));
				$("#ais_TimeSelections").find(".dateInputStop").datepicker("setDate", Helpers.parseDate(settings.startEndPeriod.strStopDate));
			} else {
				$("#ais_TimeSelections").find(".dateInputStart").datepicker("setDate", Helpers.strToDate($("#ais_TimeSelections").find(".dateInputStart").attr("defaultdate")));
				$("#ais_TimeSelections").find(".dateInputStop").datepicker("setDate", Helpers.strToDate($("#ais_TimeSelections").find(".dateInputStop").attr("defaultdate")));
			}

			$('#ais_txtHeaderContent').val(settings.headerContent);
			$('#ais_ddlText').val(settings.textType);
			$('#ais_txtNoOfTopics').val(settings.noOfTopics);
			$('#ais_maxNoOfWords').val(settings.maxNoOfWords);
			$('#ais_chkShowInformation').attr('checked', settings.showInfoBox);
			$('#ais_txtInformationLabel').val(settings.infoLabel);
			$('#ais_txtInformationContent').val(settings.infoContent);
			$('#ais_ddlInformationSize').val(settings.infoBoxSize);
			$('#ais_chkShowDisclaimer').attr('checked', settings.showDisclaimer);
			$('#ais_ddlDisclaimerType').val(settings.disclaimerType);
			$('#ais_txtDisclaimer').val(settings.disclaimerText);
			$("#ais_chkShowRefreshBtn").attr('checked', settings.showRefreshButton);
			$('#ais_ddlRefreshHorizontalPos').val(settings.refreshHorizontalPos);
			$('#ais_ddlRefreshVerticalPos').val(settings.refreshVerticalPos);
			$('#ais_ddlInfoHorizontalPos').val(settings.infoHorizontalPos);
			$('#ais_ddlInfoVerticalPos').val(settings.infoVerticalPos);
			$('#ais_ddlLanguage').val(settings.outputLanguage || 'detected');

			SummarySetup.setSelectedFilters(settings.filters);
			SummarySetup.setOptionalFilterSettings(settings.optionalFilters);
			SummarySetup.setStyles(settings.styles);
		}

		SummarySetup.enableDisableMoveButton();
		SummarySetup.showHideInformationSettings();
		SummarySetup.showHideTextSettings();
		SummarySetup.showHideDisclaimerSettings();
		SummarySetup.showHideRefreshSettings();

		if ($("#ddlDateVarAIS option").length <= 1)
			$(".aisDateVar").hide();
		else
			$(".aisDateVar").show();
	},
	setSelectedQuestions: function (questions) {
		$('#ais_selectedVarBox').empty();
		var output = [];
		questions.forEach(function (q) {
			if ($('#ais_selectedVarBox').find("option[value='" + q + "']").length == 0) {
				var qnOption = $('#ais_availVarBox').find('option[value="' + q + '"]').get(0);
				if (qnOption) output.push(qnOption.cloneNode(true));
			}
		});
		$('#ais_selectedVarBox').append(output);
		SummarySetup.clearMovedVariables();
	},
	setSelectedFilters: function (filterArray) {
		HTMLHelpers.setSelectedValues($("#ais_FilterBox div select"), 0);
		if (filterArray) {
			filterArray.forEach(function (f) {
				if (!f.filterId) return;
				var filterbox = $("#ais_FilterBox div #hidFilterId[value='" + f.filterId + "']").parent();

				if (f.allAnswers)
					HTMLHelpers.setSelectedValues(filterbox.find('select'), "all");
				else {
					var answerIds = $.map(f.answers, function (e) { return isNaN(e.answerId) ? e : e.answerId });
					HTMLHelpers.setSelectedValues(filterbox.find('select'), answerIds);
				}
			});
		}
	},
	setOptionalFilterSettings: function (optionalFilters) {
		$(".ais_chkOptFilter, #ais_chkOptHFilter, #ais_chkOptTimePeriod, #ais_chkOptVS").attr('checked', true);
		if (optionalFilters) {
			optionalFilters.forEach(function (os) {
				if (!os.settingType) return;

				if (os.settingType == 1)
					$("#ais_chkOptVS").attr("checked", os.apply);

				if (os.settingType == 2) {
					$("#ais_chkOptHFilter").attr("checked", os.apply);
				}
				else if (os.settingType == 3) {
					SummarySetup.setOptionalFilterQuestions(os.questionId, os.apply);
				}
				else if (os.settingType == 4) {
					$("#ais_chkOptTimePeriod").attr("checked", os.apply);
				}
			});
		}

		var allChecked = $('#optionalFilterSettingsAIS input[type="checkbox"]')
			.filter(function () { return $(this).attr('id') !== 'chkOptFilter'; })
			.filter(function () { return !$(this).is(':checked'); })
			.length === 0;

		$('#optionalFilterSettingsAIS')
			.prev('.optionalFilterSettingsCheckAll').find('input[type="checkbox"]')
			.attr('checked', allChecked);
	},
	setOptionalFilterQuestions: function (questionId, apply) {
		$("#ais_optFilterBox div").each(function () {
			if (questionId == parseInt($(this).find("#hidOptQuestionId").val() || "0")) {
				$(this).find(".ais_chkOptFilter").attr("checked", apply);
			}
		});
	},
	setStyles: function (styles) {
		if (!styles || styles.length == 0)
			styles = SummarySetup.getDefaultStyles();

		styles.forEach(function (style) {
			var sKey = style.settingKey;
			var sValue = style.settingValue;

			var elem = '#ais_' + sKey;

			if ($(elem).is('input:text') && sValue != '') {
				if ($(elem).hasClass('colorpicker-target')) {
					// Colorpicker
					if (sKey.indexOf('_colorPlaceholderId')) {
						colorId = sValue;
						color = styles.filter(function (style) { return style.settingKey === sKey.replace('_colorPlaceholderId', ''); })[0];
						color = color ? color.settingValue : null;
					} else {
						colorId = styles.filter(function (style) { return style.settingKey === sKey + '_colorPlaceholderId'; })[0];
						colorId = colorId ? colorId.settingValue : null;
						color = sValue;
					}

					$(elem).DUIColorPicker({
						layout: 'template',
						selected: {
							colorString: color,
							templateColorId: colorId
						}
					});
				} else {
					// textbox
					$(elem).val(sValue);
				}
				$(elem).change();
			} else if ($(elem).is('input:checkbox')) {
				// checkbox
				$(elem).attr('checked', (sValue == 'True') ? 'checked' : '');
			} else if ($(elem).is('select') && sValue != '') {
				// dropdownlist
				$(elem).val(sValue);
			} else if ($(elem).is('span')) {
				//check box list
				var cblist = $(elem).find('input:checkbox');
				var cbvalues = sValue.split(';');
				$.each(cbvalues, function () {
					if (this.indexOf(":") > 0) {
						var keyVal = this.split(':');
						cblist.filter('input:checkbox[value="' + keyVal[0] + '"]').attr('checked', (keyVal[1].toLowerCase() == 'true') ? 'checked' : '');
					}
				});
			}
		});
	},
	getSummarySettings: function () {
		var settings = {};
		settings.summaryId = $('#hidSummaryId').val();
		settings.selectedQuestions = SummarySetup.getSelectedQuestions();
		settings.filters = SummarySetup.getFilters();
		settings.optionalFilters = SummarySetup.getOptionalFilterSetting();
		settings.styles = SummarySetup.getStyles();

		settings.timePeriod = $("#ais_TimeSelections").find(".tpcDropDown").val() || 0;
		settings.dateVariableId = $('#ddlDateVarAIS').val() || 1;
		settings.timePeriodSpan = $("#ais_TimeSelections").find("#ddlTimePeriodSpan").val() || 1;
		settings.timePeriodSpanAmount = $("#ais_TimeSelections").find("#txtTimePeriod").val() || 0;
		settings.startEndPeriod = SummarySetup.getStartEndPeriod();
		settings.headerContent = $('#ais_txtHeaderContent').val();
		settings.textType = $('#ais_ddlText').val();
		settings.noOfTopics = $('#ais_txtNoOfTopics').val();
		settings.maxNoOfWords = $('#ais_maxNoOfWords').val();
		settings.showInfoBox = $("#ais_chkShowInformation").is(':checked');
		settings.infoLabel = $('#ais_txtInformationLabel').val();
		settings.infoContent = $('#ais_txtInformationContent').val();
		settings.infoBoxSize = $('#ais_ddlInformationSize').val();
		settings.showDisclaimer = $("#ais_chkShowDisclaimer").is(':checked');
		settings.disclaimerType = $('#ais_ddlDisclaimerType').val() || 1;
		settings.disclaimerText = $('#ais_txtDisclaimer').val();
		settings.showRefreshButton = $("#ais_chkShowRefreshBtn").is(':checked');
		settings.refreshHorizontalPos = $('#ais_ddlRefreshHorizontalPos').val();
		settings.refreshVerticalPos = $('#ais_ddlRefreshVerticalPos').val();
		settings.infoHorizontalPos = $('#ais_ddlInfoHorizontalPos').val();
		settings.infoVerticalPos = $('#ais_ddlInfoVerticalPos').val();
		settings.outputLanguage = $('#ais_ddlLanguage').val();

		return settings;
	},
	getSelectedQuestions: function () {
		var variables = [];
		$('#ais_selectedVarBox option').each(function () { variables.push(this.value); });
		return variables;
	},
	getStartEndPeriod: function () {
		var timeStartEnd = {};
		timeStartEnd.startDate = Helpers.formatDate($("#ais_TimeSelections").find('.dateInputStart').datepicker('getDate'));
		timeStartEnd.stopDate = Helpers.formatDate($("#ais_TimeSelections").find('.dateInputStop').datepicker('getDate'));
		return timeStartEnd;
	},
	getFilters: function () {
		var filters = [];

		$("#ais_FilterBox > div:not(.ais_filterboxTemplate)").each(function () {
			var filterId = $(this).find("#hidFilterId").val();
			var questionId = $(this).find('#hidQuestionId').val();
			var allAnswers = $(this).find("select option[value='all']:selected").length > 0;

			var selectedAnswers = $(this).find(allAnswers ? "select option" : "select option:selected").
				filter(function () { return $(this).val() != "0" && $(this).val() != "all"; }).
				map(function () {
					return { answerId: $(this).val(), answerText: $(this).text() };
				}).toArray();

			if ($(selectedAnswers).length > 0) {
				var Filter = {
					filterId: filterId,
					answers: selectedAnswers,
					questionId: questionId,
					allAnswers: allAnswers
				};

				filters.push(Filter);
			}
		});

		return filters;
	},
	getOptionalFilterSetting: function (settingId) {
		var optFilterSettings = [];
		var rowVS = new Object();
		rowVS.settingId = parseInt(settingId || "0");
		rowVS.settingType = 1;
		rowVS.apply = $("#ais_chkOptVS").is(":checked");
		optFilterSettings.push(rowVS);

		var rowHFilter = new Object();
		rowHFilter.settingId = parseInt(settingId || "0");
		rowHFilter.settingType = 2;
		rowHFilter.apply = $("#ais_chkOptHFilter").is(':checked');
		optFilterSettings.push(rowHFilter);

		$("#ais_optFilterBox div").each(function () {
			var rowFilter = new Object();
			rowFilter.SettingId = parseInt(settingId || "0");
			rowFilter.filterId = parseInt($(this).find("#hidOptFilterId").val() || "0");
			rowFilter.questionId = parseInt($(this).find("#hidOptQuestionId").val() || "0");
			rowFilter.settingType = 3;
			rowFilter.apply = $(this).find('.ais_chkOptFilter').is(':checked');
			if (rowFilter.filterId > 0)
				optFilterSettings.push(rowFilter);
		});

		var rowTimePeriod = new Object();
		rowTimePeriod.settingId = parseInt(settingId || "0");
		rowTimePeriod.settingType = 4;
		rowTimePeriod.apply = $("#ais_chkOptTimePeriod").is(':checked');
		optFilterSettings.push(rowTimePeriod);

		return optFilterSettings;
	},
	getStyles: function () {
		var styles = [];

		var styleDiv = $("#ais_layout");
		var styleList = $(styleDiv).find("[id^=ais_]");
		$(styleList).each(function (index) {
			var dictItem = {};
			var key = $(this).attr("id").substring(4);
			dictItem.settingKey = key;
			if ($(this).is('input:text')) {
				if ($(this).hasClass('numInput'))
					dictItem.settingValue = $(this).val();
				else {
					dictItem.settingValue = $(this).attr("title");
					if (dictItem.settingValue == "") {
						dictItem.settingValue = "#000000";
					}
				}
			}
			else if ($(this).is('input:checkbox')) {
				dictItem.settingValue = $(this).is(':checked');
			}
			else if ($(this).is('input:radio')) {
				dictItem.settingValue = $(this).is(':checked');
			}
			else if ($(this).is('select') || $(this).is('input:hidden')) {
				dictItem.settingValue = $(this).val();
			} else if ($(this).is('span')) {
				var cblist = $(this).find('input:checkbox');
				var cbvalues = "";
				$.each(cblist, function () {
					var cbVal = $(this).val();
					var cbChecked = $(this).is(':checked');
					cbvalues += cbVal + ":" + cbChecked + ";";
				});
				dictItem.settingValue = cbvalues;
			}
			if (dictItem.settingValue != undefined && dictItem.settingValue != null) {
				styles.push(dictItem);
			}

			// Create template color setting
			if ($(this).hasClass('colorpicker-target') && $(this).DUIColorPicker('get.selectedColorId')) {
				var dictPlaceholder = {
					settingKey: key + '_colorPlaceholderId',
					settingValue: $(this).DUIColorPicker('get.selectedColorId')
				};
				if (dictPlaceholder.settingValue != undefined && dictPlaceholder.settingValue != null) {
					styles.push(dictPlaceholder);
				}
			}
		});

		return styles;
	},
	saveSetup: function (layoutElementItem) {
		var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem);
		var leguid = layoutElement.guid;

		var settings = SummarySetup.getSummarySettings();
		if (settings.selectedQuestions.length != 1) {
			Storyboard.LayoutControls.showError("Please select one variable");
			return false;
		}

		Helpers.perfJSonCall({
			method: 'SaveSummarySettings',
			message: locale.get('Saving summary settings'),
			service: 'SummarySetup',
			data: {
				guid: layoutElementItem.guid,
				layoutElementItemId: layoutElementItem.elementItemId || 0,
				settings: settings
			},
			successCallback: function (result) {
				Storyboard.LayoutControls.showMessage(locale.get("Summary settings have been saved."));

				var items = [layoutElement];
				Storyboard.LayoutDesigner.loadStorytellerContentForElements(items, true, false, 0, 0, null, leguid, false);

				if (result.status == "OK" && !Storyboard.LayoutDesigner.isUnsaved)
					Storyboard.LayoutDesigner.refreshSlideToplineCompatibility();
			},
			failCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to save summary settings."));
			}
		});
		return true;
	},
	showPreview: function (skipCache) {
		var previewDiv = $("#ais_divPreview").empty();
		previewDiv.css("width", SummarySetup.currentLayoutElementItem.width);
		previewDiv.css("height", SummarySetup.currentLayoutElementItem.height);

		Helpers.perfJSonCall({
			method: 'GetSummaryPreview',
			message: locale.get('Generating preview'),
			service: 'SummarySetup',
			data: {
				settings: SummarySetup.getSummarySettings(),
				generalSettings: GeneralSettings.getSelectedSettings(),
				skipCache: skipCache || false
			},
			successCallback: function (summaryData) {
				SummarySetup.renderSummary(previewDiv, summaryData, SummarySetup.currentLayoutElementItem.guid);
			},
			failCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to generate preview."));
			},
			fixCasing: true
		});
	},
	eventUpdateSummary: function (layoutElement, summaryData) {
		var itemTypes = Storyboard.Constants.itemTypes;
		var aisElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.SUMMARY, layoutElement);
		var summaryDiv = $(".layoutElementItem[guid='" + aisElem.guid + "']");
		Helpers.fixDotnetCasing(summaryData);

		SummarySetup.renderSummary(summaryDiv, summaryData, aisElem.guid);
	},
	redrawSummary: function (layoutElementItem) {
		if (layoutElementItem != null) {
			layoutElementItem.content = '';
			$('#' + layoutElementItem.guid).html('');
			if (layoutElementItem.guid != "") { // element already has been saved
				var summaryData = Storyboard.SummaryCache.getSummaryDataFromCache(layoutElementItem.guid);
				if ((typeof summaryData != 'undefined') && (summaryData != null)) {
					var sDiv = $(".layoutElementItem[guid='" + layoutElementItem.guid + "']");
					SummarySetup.renderSummary(sDiv, summaryData, layoutElementItem.guid);
				}
			}
		}
	},
	refreshMyStoriesSummary: function (layoutElement) {
		var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
		Helpers.perfJSonCall({
			method: "RefreshStorySummary",
			data: { storyId: $("#ddlMyStories").val(), slideId: slide.slideId, summaryElement: layoutElement },
			successCallback: function (result) {
				var iOS = /iPad|iPhone|iPod|Mac/.test(navigator.userAgent) && !window.MSStream;
				if (iOS) {
					if (callback) {
						callback();
						if (result.initGetData)
							Storyboard.LayoutDesigner.getProcessedData();
					} else {
						if (result.initGetData)
							setTimeout(Storyboard.LayoutDesigner.getProcessedData, 200);
					}
				} else {
					if (result.initGetData)
						Storyboard.LayoutDesigner.getProcessedData();
				}
			}
		});
	},
	renderSummary: function (summaryDiv, summaryData, elementItemGuid) {
		$(summaryDiv).empty();
		Storyboard.SummaryCache.setSummaryDataToCache(summaryData, elementItemGuid);

		if (summaryData == null || summaryData.text == null || summaryData.text.text.length == 0) {
			if (Storyboard.LayoutDesigner.useNewNoDataLayout) {
				$(summaryDiv).removeClass("layoutElementSummary").addClass("layoutElementNoDataText")
					.html($('<span/>', { 'class': 'noData', html: locale.get('no data') }))
					.css({ 'background-image': '' });
			} else {
				$(summaryDiv).html("No Data");
			}
		} else {
			$(summaryDiv).removeClass("layoutElementNoDataText").addClass("layoutElementSummary").css("background", "transparent");

			$(summaryDiv).append('<table style="width:100%;">' +
				'<tr><td colspan="3" class="div_summary_top"></td></tr>' +
				'<tr><td class="div_summary_left"><td class="div_summary_content"><td class="div_summary_right"></td></tr>' +
				'<tr><td colspan="3" class="div_summary_bottom"></td></tr></table>');

			var summaryContentDiv = $(summaryDiv).find('.div_summary_content');

			if (summaryData.header && summaryData.header.text) {
				$(summaryContentDiv).append('<div class="div_summary_header" style="' + summaryData.header.style + '">' + summaryData.header.text + '</div>');
			}

			$(summaryContentDiv).append('<div class="div_summary_content" style="' + summaryData.text.style + '">' + summaryData.text.text + '</div>');

			if (summaryData.disclaimer && summaryData.disclaimer.text) {
				if (summaryData.disclaimer.type == 1) { // Footer
					$(summaryContentDiv).append('<div class="div_summary_disclaimer" style="' + summaryData.disclaimer.style + '">' + summaryData.disclaimer.text + '</div>');
				} else { // Tooltip
					$(summaryContentDiv).attr('title', summaryData.disclaimer.text);
				}
			}

			if (summaryData.refreshButton.show) {
				var btnContainer = SummarySetup.getButtonContainer($(summaryDiv), summaryData.refreshButton.verticalPos, summaryData.refreshButton.horizontalPos);

				$(btnContainer).append('<button type="button" class="DUIButtonIcon summaryReload" style="margin: 2px;" title="For updated results, force new analysis"><i class="DUI-icon DUI-icon--c DUI-icon-loop"></i></button>');

				$(summaryDiv).find('button.summaryReload').click(function (event) {
					var timer = Storyboard.SummaryCache.getSummaryReloadTimer(elementItemGuid);

					if (timer == null || Date.now() > (timer.start + timer.duration)) {
						var layoutElementItem = Storyboard.LayoutDesigner.getElementItemByGuid(elementItemGuid);
						var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem);
						var items = [layoutElement];

						if ($(summaryDiv).attr('id') == "ais_divPreview")
							SummarySetup.showPreview(true);
						else if (window.IsMyStories) {
							SummarySetup.refreshMyStoriesSummary(layoutElement);
						}
						else if (window.IsStoryboard)
							Storyboard.LayoutDesigner.loadStorytellerContentForElements(items, false, false, 0, 0, null, elementItemGuid, true);

						$(summaryDiv).find('.summaryReload').html('<img src="images/spinner.gif" style="width:20px;height:20px;padding: 4px 7px;"/>');

						var timeOut = timer == null ? 4000 : timer.duration * 2;
						Storyboard.SummaryCache.setSummaryReloadTimer(elementItemGuid, timeOut);
					}
				});

				var timer = Storyboard.SummaryCache.getSummaryReloadTimer(elementItemGuid);
				if (timer != null && Date.now() < (timer.start + timer.duration)) {
					var disableDuration = timer.start + timer.duration - Date.now();
					$(summaryDiv).find('.summaryReload').attr('disabled', 'disabled');
					setTimeout(function () {
						$(summaryDiv).find('.summaryReload').removeAttr('disabled');
					}, disableDuration);
				}

				SummarySetup.alignButton($(summaryDiv).find('.summaryReload'), summaryData.refreshButton.horizontalPos, summaryData.refreshButton.verticalPos);
			}

			if (summaryData.infoBox && summaryData.infoBox.show) {
				var btnContainer = SummarySetup.getButtonContainer($(summaryDiv), summaryData.infoBox.verticalPos, summaryData.infoBox.horizontalPos);
				$(btnContainer).append('<button type="button" class="DUIButtonIcon summaryInfo" style="margin: 2px;"><i class= "DUI-icon DUI-icon--c DUI-icon-info"></i></button>');

				$(summaryDiv).find('button.summaryInfo').click(function (event) {
					var html = '<p>' + summaryData.infoBox.content + '</p>';
					var width = summaryData.infoBox.size * 200;

					new DUIwindow2({
						title: '<h2>' + summaryData.infoBox.label + '</h2>',
						html: html,
						width: width,
						buttons: [],
						afterShow: function () {
							$(event.currentTarget).addClass('dui-window-open-target');
						},
						afterClose: function () {
							setTimeout(function () { $(event.currentTarget).removeClass('dui-window-open-target'); }, 1);
						}
					});
				});

				SummarySetup.alignButton($(summaryDiv).find('.summaryInfo'), summaryData.infoBox.horizontalPos, summaryData.infoBox.verticalPos);
			}
		}

		$(summaryDiv).show();
		Storyboard.LayoutControls.hideLoadingBar();

		if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
			var slideId = $(summaryDiv).closest(".layoutSlide").attr('slideid');
			if (slideId) {
				var slide = Storyboard.LayoutDesigner.getSlideById(slideId);
				Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
			}
		}
	},
	getButtonContainer: function (summaryDiv, verticalPos, horizontalPos) {
		if (verticalPos == SummarySetup.verticalPosition.TOP) {
			return $(summaryDiv).find('.div_summary_top');
		} else if (verticalPos == SummarySetup.verticalPosition.BOTTOM) {
			return $(summaryDiv).find('.div_summary_bottom');
		} else {
			if (horizontalPos == SummarySetup.horizontalPosition.LEFT) {
				return $(summaryDiv).find('.div_summary_left');
			} else if (horizontalPos == SummarySetup.horizontalPosition.RIGHT) {
				return $(summaryDiv).find('.div_summary_right');
			}
		}
	},
	alignButton: function (btn, horizontalPos, verticalPos) {
		// placed on top or bottom, apply horizontal position
		if (verticalPos == SummarySetup.verticalPosition.TOP || verticalPos == SummarySetup.verticalPosition.BOTTOM) {
			if (horizontalPos == SummarySetup.horizontalPosition.RIGHT)
				$(btn).css('float', 'right');
			else if (horizontalPos == SummarySetup.horizontalPosition.CENTER)
				$(btn).css('left', '50%').css('transform', 'translateX(-50%)');
			else
				$(btn).css('left', '0');
		} else if (verticalPos == SummarySetup.horizontalPosition.CENTER)
			$(btn).css('top', '50%').css('transform', 'translateY(-50%)');
	},
	showHideInformationSettings: function () {
		$('#ais_Information').toggle($('#ais_chkShowInformation').is(':checked'));
	},
	showHideTextSettings: function () {
		$('.aisNoOfTopics').toggle($('#ais_ddlText').val() != 1);
	},
	showHideDisclaimerSettings: function () {
		$('#ais_Disclaimer').toggle($('#ais_chkShowDisclaimer').is(':checked'));
	},
	showHideRefreshSettings: function () {
		$('#ais_Refresh').toggle($('#ais_chkShowRefreshBtn').is(':checked'));
	},
	getDefaultStyles: function () {
		var defaultFont = Storyboard.LayoutDesigner.getDefaultFont().Family;

		return [
			{ settingKey: 'header_font', settingValue: defaultFont },
			{ settingKey: 'header_fontsize', settingValue: '10px' },
			{ settingKey: 'header_fontcolor', settingValue: '#262626' },
			{ settingKey: 'header_textalignment', settingValue: 'Left' },
			{ settingKey: 'header_fontstyle', settingValue: 'Bold:false;Italic:false;Underline:false;' },
			{ settingKey: 'header_padding', settingValue: '10' },

			{ settingKey: 'text_font', settingValue: defaultFont },
			{ settingKey: 'text_fontsize', settingValue: '10px' },
			{ settingKey: 'text_fontcolor', settingValue: '#262626' },
			{ settingKey: 'text_textalignment', settingValue: 'Left' },
			{ settingKey: 'text_fontstyle', settingValue: 'Bold:false;Italic:false;Underline:false;' },
			{ settingKey: 'text_padding', settingValue: '10' },

			{ settingKey: 'disclaimer_font', settingValue: defaultFont },
			{ settingKey: 'disclaimer_fontsize', settingValue: '10px' },
			{ settingKey: 'disclaimer_fontcolor', settingValue: '#262626' },
			{ settingKey: 'disclaimer_textalignment', settingValue: 'Left' },
			{ settingKey: 'disclaimer_fontstyle', settingValue: 'Bold:false;Italic:false;Underline:false;' },
			{ settingKey: 'disclaimer_padding', settingValue: '10' },
		];
	},
	initWizard: function (templateId) {
		var $setup = $('#setupSummaryTab');

		// Append controls to Wizard
		$('#wizardSummaryVariables').append($setup.find('#ais_variables .settingsFieldsetContent'));
		$('#wizardSummaryFilters').append($setup.find('#ais_FilterBox'));
		$('#wizardSummaryTime').append($setup.find('#ais_TimeSelections').removeClass('settingsFieldsetContent'));
		$('#wizardSummaryPreview').append($setup.find('#ais_divPreview'));

		$('#wizardSummaryVariables .availVarBox, #wizardSummaryVariables .selectedVarBox').addClass('size-1-2');

		$('#wizardSummaryPreviewButton').unbind('click.setupWizard').bind('click.setupWizard', function () { SummarySetup.showPreview(false); });

		// Hide
		$setup.find('#summarytabholder').css('display', 'none');
		$('#DUI-ST-MULTIEDIT').css('display', 'none');
		$('#wizardSummary').css('display', '').find('.tabs + .expandable > .settingsFieldsetLegend').trigger('click');
		$('#setupHolder').addClass('setupWizard');
	},
	destroyWizard: function () {
		var $setup = $('#setupSummaryTab');

		if ($('#summarytabholder > .tabs .setupWizardInit').length === 0) {
			$setup.find('#summarytabholder > .tabs').prepend('<li class="ui-state-default setupWizardInit"><a>Wizard</a></li>');
			$('#summarytabholder > .tabs .setupWizardInit').bind('click', SummarySetup.initWizard);
		}

		$('#wizardSummaryVariables .availVarBox, #wizardSummaryVariables .selectedVarBox').removeClass('size-1-2');

		// Append controls to chart setup
		$setup.find('#ais_variables').append($('#wizardSummaryVariables .settingsFieldsetContent'));
		$setup.find('#ais_filters .settingsFieldset:first-child .settingsFieldsetLegend + .settingsFieldsetContent')
			.append($('#wizardSummaryFilters #ais_FilterBox'));
		$setup.find('#ais_settings .settingsFieldset:first-child').append($('#ais_TimeSelections').addClass('settingsFieldsetContent'));
		$setup.find('.preview-groupings > div').append($setup.find('#ais_divPreview'));

		$setup.find('#summarytabholder, #DUI-ST-MULTIEDIT').css('display', '');
		$('#DUI-ST-MULTIEDIT').css('display', 'none');
		$('#wizardSummary').css('display', 'none');
		$('#setupHolder').removeClass('setupWizard');
	},
	removeWizard: function () {
		if ($('#setupHolder').hasClass('setupWizard')) SummarySetup.destroyWizard();
		$('#summarytabholder > .tabs .setupWizardInit').remove();
	}
};